import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { style } from '@vanilla-extract/css';

export const semiCircleContainer = style({
  display: 'flex',
  alignItems: 'center',
});

export const semiCircleProgressBarContainer = style({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
});

export const semiCircleProgressBar = style([
  responsiveStyle({
    mobile: {
      width: '47px',
      height: '28px',
    },
    laptop: {
      width: '66px',
      height: '36px',
    },
  }),
]);

export const smallSemiCircleProgressBar = style({
  ...responsiveStyle({
    mobile: {
      width: '38px',
      height: '28px',
    },
    laptop: {
      width: '38px',
      height: '28px',
    },
  }),
});
